import HiddenTypography from 'components/hidden-typography/hidden-typography.component';
import { useTranslation } from 'react-i18next';
import { setDeletedItem } from 'redux/cart/cart.actions';
import { selectDeletedItem } from 'redux/cart/cart.selectors';
import { useReduxSrAlert } from '../sr-alerts.hooks';

const SrItemRemovedAlert = () => {
  const { t } = useTranslation();
  const alertMessage = useReduxSrAlert(
    selectDeletedItem,
    deletedItem => t('itemRemovalSrAlert', { itemName: deletedItem }),
    () => setDeletedItem(null),
  );

  return <HiddenTypography role="alert">{alertMessage}</HiddenTypography>;
};
export default SrItemRemovedAlert;
